import gql from "graphql-tag";

const ALERT_MESSAGE_QUERY = gql`
query alertmessage($locale: I18NLocaleCode) {
  alertMessages(locale: $locale) {
    data {
      attributes {
        locator
        title
        short_description
        full_description
        variant
        localizations {
          data {
            attributes {
              locale
              locator
              title
              short_description
              full_description
              variant
            }
          }
        }
      }
    }
  }
}
`;

export default ALERT_MESSAGE_QUERY;
